import { j as e } from "./react-944c88e2.js";
import { B } from "./@chakra-ui-f377b543.js";
import { u as x, m as j, i as v, g as t } from "./useAccount-8a1c7225.js";
import "react";
import "./usehooks-ts-53aa4768.js";
import { g as A, a as D, b as L, c as u } from "./domains-162ab8d8.js";
import "./features-4c20b5b5.js";
import "./eMyAsurionProvider-ec3ed988.js";
import "./myasurion-shared.mixpanel.es.js";
import "./contentful-a9b11b75.js";
import "./@firebase-868b0e52.js";
import "@chakra-ui/react";
import "@tanstack/react-query";
import "@chakra-ui/icons";
import "./providers-e896aa48.js";
const q = ({
  headerComponent: h,
  bypass: i = !1,
  env: n,
  children: f
}) => {
  var m, p, d, l;
  const [w] = x({ profileId: "", userId: "" }), [y] = j({ authorization: "", token: "", id: "" }), r = A(), a = D(), s = L(), c = v(w, y);
  if (!i) {
    if (!c)
      if (console.log(`Unauthorized user redirecting to ${t("/login")}`), r === "shared") {
        const o = sessionStorage.getItem("p"), g = u(
          a,
          o === "device_protection" || o === "repair" || o === "shared" ? o : "device_protection",
          (p = (m = n ?? s) == null ? void 0 : m.toString()) == null ? void 0 : p.toLowerCase(),
          !0
        );
        window.location.href = g ? g + "/login?logoutRedirect=true" : t("/login?logoutRedirect=true");
      } else
        window.location.href = t("login");
    !window.location.pathname.startsWith("/login") && r !== "shared" && window.location.origin === u(
      a,
      r,
      (l = (d = n ?? s) == null ? void 0 : d.toString()) == null ? void 0 : l.toLowerCase(),
      !0
    ) && (window.location.href = t("login"));
  }
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: (i || c) && /* @__PURE__ */ e.jsxs(B, { id: "myasurion-protected-layout", children: [
    h,
    f
  ] }) });
};
export {
  q as P
};
